import { useEffect, useState } from "react";
import Api from "../openapi";

export default function useZones() {
  const [zoneList, setZoneList] = useState<number[]>([]);

  useEffect(() => {
    const getZones = async () => {
      try {
        const res = await Api.Zone.listZones();
        setZoneList(res.data);
      } catch (error) {}
    };
    getZones();
  }, []);
  return zoneList;
}
